import { useEffect, useState } from 'react'
import { InputAdornment, TextField, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import d2lIntl from 'd2l-intl'
import { debounce } from 'lodash'
import { fsColors } from '../../shared/constants'
import { useAppSelector } from '../../store/hooks'

const FsOFATextField = ({ value, onChange, max, unit, noDebounce = false }: any) => {
  const { currentLanguage, currentTheme } = useAppSelector((state) => state.currentUser)
  const [curCost, setCurCost] = useState<string>('')
  const { t } = useTranslation()

  const debouncedCallback = debounce((val: string) => {
    if (onChange)
      onChange(
        val
          ? currentLanguage === 'de'
            ? new d2lIntl.NumberParse('de-DE').parse(val.replace(/\./g, '').replace(/,/, '.'))
            : new d2lIntl.NumberParse('en-US').parse(val)
          : 0,
      )
  }, 500)

  useEffect(() => {
    setCurCost(
      value
        ? Number(value).toLocaleString(currentLanguage, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        : '',
    )
  }, [currentLanguage])

  const isNumber = /([0-9]*[.])?[0-9]*[^a-zA-Z\u00C0-\u017F]$/

  return (
    <TextField
      variant="outlined"
      size="small"
      type="text"
      inputMode="numeric"
      value={curCost}
      placeholder={t('enter.the.number')}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        if (!event.target.value || isNumber.test(event.target.value)) {
          setCurCost(event.target.value)
          if (noDebounce && onChange) {
            onChange(
              event.target.value
                ? currentLanguage === 'de'
                  ? new d2lIntl.NumberParse('de-DE').parse(
                      event.target.value.replace(/\./g, '').replace(/,/, '.'),
                    )
                  : new d2lIntl.NumberParse('en-US').parse(event.target.value)
                : 0,
            )
          } else {
            debouncedCallback(event.target.value)
          }
        }
      }}
      sx={{ mx: 1 }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Typography>{unit}</Typography>
          </InputAdornment>
        ),
        inputProps: {
          max: max ? Number(max) : undefined,
          min: 0,
          style: {
            height: '17px',
            fontSize: '16px',
            color: currentTheme === 'dark' ? fsColors.fsGray.light : fsColors.fsGray.primary,
          },
          lang: currentLanguage,
        },
      }}
      error={curCost !== '' && !curCost}
    />
  )
}

export default FsOFATextField
